import { Component, OnInit } from '@angular/core';
import { OttoOlsenFilterSearchCrossReferenceListConfigService } from '../../services/otto-olsen-filter-search-cross-reference-list-config.service';
import { AuthService, GungFlowService, SelectedCustomerService } from 'gung-standard';
import { first, forkJoin, of, switchMap } from 'rxjs';

@Component({
    selector: 'otto-olsen-filter-search-cross-reference-list',
    templateUrl: './otto-olsen-filter-search-cross-reference-list.component.html',
    styleUrl: './otto-olsen-filter-search-cross-reference-list.component.scss',
    standalone: false
})
export class OttoOlsenFilterSearchCrossReferenceListComponent implements OnInit {
  protected firstSearch: boolean = false;
  protected searchInput: string = '';
  protected minLengthError: boolean = false;

  constructor(
    protected configService: OttoOlsenFilterSearchCrossReferenceListConfigService,
    protected selectedCustomerService: SelectedCustomerService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService
  ) {}

  ngOnInit(): void {
    this.selectedCustomerService
      .getSelectedCustomer()
      .pipe(
        first(),
        switchMap(selectedCustomer =>
          forkJoin({
            selectedCustomer: of(selectedCustomer),
            selectedFlow: this.gungFlowService.getSelectedFlow().pipe(first())
          })
        )
      )
      .subscribe(({ selectedCustomer, selectedFlow }) => {
        this.configService.flowId = selectedFlow.id;
        this.configService.customerId = selectedCustomer.id;
      });
  }

  onSearchInputChanged(): void {
    if (!!this.searchInput && this.searchInput.length < 3) {
      this.minLengthError = true;
    } else {
      this.minLengthError = false;
    }
  }

  search(): void {
    if (this.searchInput.length < 3) {
      return;
    }
    this.configService.search.next(this.searchInput);
    this.firstSearch = true;
  }
}
